import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";

function ServicesPage() {
  return (
    <div className="min-h-screen bg-white text-black">
      <Navbar />
      <main>
        <section className="page-hero">
          <div className="container">
            <span className="eyebrow">
              Services | Federal IT | Modernization
            </span>
            <h1>
              Services built for modernization, security, and mission outcomes
            </h1>
            <p>
              ThoughtCodes delivers integrated engineering, cybersecurity,
              cloud, DevSecOps, and automation services to help government and
              mission-driven organizations modernize systems, improve security,
              and accelerate delivery in compliance-driven environments.
            </p>
          </div>
        </section>
        <section className="section gradient-bg">
          <div className="container">
            <div className="grid-3">
              <div className="service stat stat-interactive !shadow-[0_12px_32px_rgba(2,6,23,0.12)]">
                <div className="icon">A</div>
                <h3>Custom Software & Application Development</h3>
                <p>
                  We design, develop, and modernize secure, scalable, and
                  user-centric applications that support mission-critical
                  operations.
                </p>
                <ul className="list-check">
                  <li>Full-stack web and mobile application development</li>
                  <li>Legacy system modernization and re-platforming</li>
                  <li>API design, microservices, and system integration</li>
                  <li>Human-centered UI/UX design (508 compliant)</li>
                  <li>Performance optimization and scalability engineering</li>
                </ul>
              </div>
              <div className="service stat stat-interactive !shadow-[0_12px_32px_rgba(2,6,23,0.12)]">
                <div className="icon">B</div>
                <h3>Agile Digital Transformation</h3>
                <p>
                  We enable organizations to adopt Agile practices and modern
                  product delivery models that improve collaboration, speed, and
                  mission alignment.
                </p>
                <ul className="list-check">
                  <li>
                    Agile coaching and framework implementation (SAFe, Scrum)
                  </li>
                  <li>Product management and backlog optimization</li>
                  <li>Iterative development and continuous delivery support</li>
                  <li>DevSecOps culture and process transformation</li>
                  <li>Program and portfolio management support</li>
                </ul>
              </div>
              <div className="service stat stat-interactive !shadow-[0_12px_32px_rgba(2,6,23,0.12)]">
                <div className="icon">C</div>
                <h3>Cloud & DevSecOps Enablement</h3>
                <p>
                  We help organizations securely migrate to the cloud and
                  implement automated, resilient DevSecOps pipelines.
                </p>
                <ul className="list-check">
                  <li>
                    Cloud architecture, migration, and optimization (AWS, Azure)
                  </li>
                  <li>
                    Infrastructure as Code (IaC) and environment automation
                  </li>
                  <li>CI/CD pipeline design and implementation</li>
                  <li>
                    Containerization and orchestration (Docker, Kubernetes)
                  </li>
                  <li>
                    Continuous security integration and compliance automation
                  </li>
                </ul>
              </div>
              <div className="service stat stat-interactive !shadow-[0_12px_32px_rgba(2,6,23,0.12)]">
                <div className="icon">D</div>
                <h3>Cybersecurity & Compliance</h3>
                <p>
                  We implement security-first solutions aligned with federal
                  standards to protect systems, data, and operations.
                </p>
                <ul className="list-check">
                  <li>NIST, FedRAMP, FISMA compliance implementation</li>
                  <li>Security architecture and risk assessments</li>
                  <li>Identity and Access Management (IAM) integration</li>
                  <li>Vulnerability management and continuous monitoring</li>
                  <li>Encryption, data protection, and audit readiness</li>
                </ul>
              </div>
              <div className="service stat stat-interactive !shadow-[0_12px_32px_rgba(2,6,23,0.12)]">
                <div className="icon">E</div>
                <h3>AI & Intelligent Automation</h3>
                <p>
                  We leverage AI and automation technologies to streamline
                  processes, reduce manual effort, and enhance decision-making.
                </p>
                <ul className="list-check">
                  <li>Robotic Process Automation (RPA)</li>
                  <li>AI/ML model integration and analytics</li>
                  <li>Workflow automation and business process optimization</li>
                  <li>Chatbots and intelligent virtual assistants</li>
                  <li>Data engineering and predictive insights</li>
                </ul>
              </div>
              <div className="service stat stat-interactive !shadow-[0_12px_32px_rgba(2,6,23,0.12)]">
                <div className="icon">F</div>
                <h3>Quality Engineering & Test Automation</h3>
                <p>
                  We ensure high-quality, reliable systems through comprehensive
                  testing strategies and automation frameworks.
                </p>
                <ul className="list-check">
                  <li>Functional, integration, and system testing</li>
                  <li>Automated testing frameworks (UI, API, performance)</li>
                  <li>Performance and load testing</li>
                  <li>Test data management and environment setup</li>
                  <li>Continuous testing within CI/CD pipelines</li>
                </ul>
              </div>
              {/* <div className="service stat stat-interactive ">
                <div className="icon">G</div>
                <h3>Enterprise Architecture & Systems Engineering</h3>
                <p>
                  We design scalable, interoperable architectures that align
                  technology solutions with mission and business goals.
                </p>
                <ul className="list-check">
                  <li>Enterprise architecture and roadmap development</li>
                  <li>System integration and interoperability design</li>
                  <li>
                    Analysis of Alternatives (AOA) and technology evaluation
                  </li>
                  <li>Data architecture and governance</li>
                  <li>Systems engineering lifecycle support</li>
                </ul>
              </div> */}
            </div>
          </div>
        </section>
        <section className="section soft gradient-bg">
          <div className="container split">
            <div>
              <div className="section-head">
                <div className="tag">Service Advantages</div>
                <h2 className="text-black font-bold !text-xl md:!text-2xl mb-4">
                  Why Government Agencies Choose ThoughtCodes for Secure Digital
                  Modernization
                </h2>
              </div>
              <ul className="list-check">
                <li>
                  Mission-aligned delivery focused on measurable operational
                  outcomes
                </li>
                <li>
                  Security-first, secure-by-design implementation across
                  applications and infrastructure
                </li>
                <li>
                  Agile, collaborative delivery with responsive and scalable
                  teams
                </li>
                <li>
                  Cloud-ready, scalable architectures built for long-term
                  sustainability
                </li>
                <li>
                  Integrated expertise across software engineering, cloud, AI,
                  and DevSecOps
                </li>
              </ul>
            </div>
            <div className="card">
              <h3>
                Aligned with Federal Mission Priorities and Technology Needs
              </h3>
              <p>
                Our services are designed to support the core priorities of
                federal agencies and program teams, including modernization,
                security, cloud adoption, and operational efficiency.
              </p>
              <ul className="list-check">
                <li>Government IT modernization services</li>
                <li>Federal software development solutions</li>
                <li>Cloud migration and DevSecOps implementation</li>
                <li>
                  Cybersecurity and compliance support (NIST, FedRAMP, FISMA)
                </li>
                <li>Systems modernization and integration</li>
                <li>AI and automation for government operations</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default ServicesPage;
